import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PublishedVersion } from 'icreate/common/models/versions-history';
import { Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-version-reference-page',
    templateUrl: './version-reference-page.component.html',
    styleUrls: ['./version-reference-page.component.css'],
    standalone: false,
})
export class VersionReferencePageComponent implements OnInit {
    @Input() versions: any[];
    @Input() vessel: Vessel;
    @Input() referenceVersion: string;
    @Input() showHistoryButton: boolean = true;
    @Output() onOpenHistory: EventEmitter<void> = new EventEmitter();
    @Output() onReferenceSelected: EventEmitter<string> = new EventEmitter();
    @ViewChild('listContainer') listContainer: ElementRef;
    @ViewChild('listInput') listInput: ElementRef;

    versionsList: { version: string; name: string }[] = [];
    selectedVersion: { version: string; name: string };

    showList: boolean = false;

    constructor(private translateService: TranslateService) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.showList &&
            !this.listContainer?.nativeElement.contains(event.target) &&
            !this.listInput?.nativeElement.contains(event.target)
        ) {
            this.showList = !this.showList;
        }
    }

    ngOnInit(): void {
        if (this.versions && this.versions.length > 0) {
            const prefix = this.translateService.instant('version.create.dialog.reference.prefix');
            this.versions.map((version: PublishedVersion) => {
                if (version.name == this.vessel.projectVersion) {
                    this.versionsList.unshift({
                        name: prefix + ' ' + version.name,
                        version: version.name,
                    });
                } else {
                    this.versionsList.push({
                        name: prefix + ' ' + version.name,
                        version: version.name,
                    });
                }
                if (this.referenceVersion && this.referenceVersion === version.name) {
                    this.selectedVersion = {
                        name: prefix + ' ' + version.name,
                        version: version.name,
                    };
                }
            });
            if (!this.referenceVersion) {
                this.selectedVersion = this.versionsList[0];
                this.onReferenceSelected.emit(this.selectedVersion.version);
            }
        }
    }

    handleVersionSelected(version) {
        this.selectedVersion = version;
        this.showList = false;
        this.onReferenceSelected.emit(this.selectedVersion.version);
    }

    openVersionHistory() {
        if (!this.showHistoryButton) return;
        this.onOpenHistory.emit();
    }
}
